
            import tailwindConfig from "@/../tailwind.config.ts";
            import "https://esm.shakespeare.diy/tailwindcss-cdn@3";
            tailwind.config = tailwindConfig;
          